<div class="animated fadeIn">
  <div class="row">
    <div class="col-md-12 mb-4">
      <button routerLink="/backoffice/configuration/languages" class="btn btn-sm btn-primary"><i class="fa fa-chevron-left"></i> Back</button>
    </div>
  </div>

  <!-- MISSING KEYS -->
  @if (missingKeys.length > 0) {
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header" (click)="isMissingKeysOpen = !isMissingKeysOpen" style="cursor:pointer">
            <span class="badge bg-danger me-2">{{ missingKeys.length }}</span> Missing keys
            <div class="pull-right">
              @if (isMissingKeysOpen) {
                <i class="fa fa-chevron-down"></i>
              } @else {
                <i class="fa fa-chevron-left"></i>
              }
            </div>
          </div>
          <div class="card-body" [collapse]="!isMissingKeysOpen">
            <div class="mb-2">
              <button class="btn btn-sm btn-warning" type="button" [disabled]="isAddingAllKeys" (click)="onClickAddAllKeys()">
                <span *ngIf="isAddingAllKeys" class="spinner-border spinner-border-sm mr-1"></span>
                <i class="fa fa-plus"></i> Add all keys
              </button>
            </div>
            <ul class="list-unstyled mb-0">
              @for (key of missingKeys; track $index) {
                <li><code>{{ key }}</code></li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- FILTERS -->
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header" (click)="isFilterOpen = !isFilterOpen" style="cursor:pointer">
          <i class="fa fa-filter"></i> Filters
          <div class="pull-right">
            @if (isFilterOpen) {
              <i class="fa fa-chevron-down"></i>
            } @else {
              <i class="fa fa-chevron-left"></i>
            }
          </div>
        </div>
        <div class="card-body" [collapse]="!isFilterOpen">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Key</label>
                <input class="form-control" placeholder="translation.key" type="text" [(ngModel)]="filters.translation_key">
              </div>
            </div>
          </div>
          <div class="filters-buttons">
            <button [disabled]="isLoading" class="btn btn-sm btn-primary" (click)="onClickFilter()"><i class="fa fa-filter"></i> Filter</button>
            <button [disabled]="isLoading" class="btn btn-sm btn-danger" (click)="onClickResetFilters()"><i class="fa fa-ban"></i> Reset</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- LIST -->
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-list"></i> Translations
        </div>
        <div class="card-body">
          <div class="mb-3">
            <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()">
              <i class="fa fa-plus"></i> Add Translation
            </button>
          </div>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Key</th>
                <th>Value</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (translation of translations; track translation.translationId; let i = $index) {
                <tr>
                  <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                  <td><code>{{ translation.translationKey }}</code></td>
                  <td style="max-width: 400px; overflow: hidden;" [innerHTML]="highlightBrackets(translation.translationValue)"></td>
                  <td>
                    <button class="btn btn-sm btn-primary me-1" type="button" (click)="onClickEdit(translation)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                    <span class="text-muted mx-1">|</span>
                    <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(translation)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <br/>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + translations.length }} of {{ totalResults }} entries
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="pageNumber <= 1">
                <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
              </li>
              @for (page of getPageNumbers(); track $index) {
                @if (page === null) {
                  <li class="page-item disabled"><span class="page-link">...</span></li>
                } @else {
                  <li class="page-item" [class.active]="page === pageNumber">
                    <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                  </li>
                }
              }
              <li class="page-item" [class.disabled]="translations.length < resultsPerPage">
                <button class="page-link" (click)="onClickPaginationNext()" [disabled]="translations.length < resultsPerPage">&raquo;</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-language-translation-add-modal #addModal [languageId]="languageId"></app-language-translation-add-modal>
<app-language-translation-edit-modal #editModal [languageId]="languageId"></app-language-translation-edit-modal>
